/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { withRouterHooks } from '../../routes/router.hooks';
import { run as runActions } from '../../store/workspaces/workspaces/run';
import { runStaticQuery } from '../../api/query/run.staticQuery';
import { useTranslation } from 'react-i18next';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import { useSelector } from 'react-redux';
import './styles.css';
import { ChatBadgeStyled, HeaderMenuContainerStyled } from './styles';
import { setEventSourceHeartBeat } from 'src/api/services/heartbeat/heartbeat';

const HeaderMenu = () => {
  const [menu, setMenu] = useState<any[]>([]);
  const badge = useSelector((state: any) => state.workspaces.badge);
  const { t } = useTranslation();

  const userImage = JSON.parse(localStorage.getItem('image') || '""');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await runStaticQuery('navigation', {
          key: null,
          uuid: 'ce6b3e7f-e0e8-4b14-9e5d-299634fd17de',
        });

        const elements = resp?.navigation?.elements || [];
        setMenu(elements);
      } catch (error) {
        console.error('Error fetchData HeaderMenu', error);
      }
    };

    fetchData();

    if (localStorage.getItem('heartbeat') === 'false') {
      setEventSourceHeartBeat();
    }

    localStorage.setItem('heartbeat', 'true');
  }, []);

  const handleClick = (args: any) => {
    const eventKey = args?.item?.key;
    runActions(eventKey, args?.item?.properties?.id, null);
  };

  if (!menu || menu.length === 0) return null;

  return (
    <HeaderMenuContainerStyled>
      <DropDownButtonComponent
        items={menu.map((element) => ({
          text: t(element.label),
          id: element.key,
          key: element.events.find((event: any) => event?.type === 'onClick')?.key,
        }))}
        iconPosition="Left"
        className="header-dropdown-item"
        select={handleClick}
      >
        <img
          src={userImage?.length === 0 ? 'favicon.svg' : userImage ?? 'favicon.svg'}
          className="w-7 h-7 rounded-full object-cover"
        />
      </DropDownButtonComponent>

      <ChatBadgeStyled empty={+!badge?.content}>
        {badge?.content ?? '0'}
      </ChatBadgeStyled>
    </HeaderMenuContainerStyled>
  );
};

export default withRouterHooks(HeaderMenu);
